// Copyright 2023-2024 - Hewlett Packard Enterprise Company
const COM_API_ROOT_URL = window.indigo.REACT_APP_COM_API_ROOT_URL;

export const PAGE_LIMIT = 1000;

export const COMPUTE_OPS_URL = `${COM_API_ROOT_URL}/compute-ops`;
export const DOORWAY_URL = `${COM_API_ROOT_URL}/ui-doorway`;
export const COBALT_URL = `${COM_API_ROOT_URL}/api`;
export const COMPUTE_OPS_MGMT_URL = `${COM_API_ROOT_URL}/compute-ops-mgmt`;
